import { CreativeOffer } from '@wix/premium-purchase-platform/@sdk';
export const DEFAULT_PURCHASE_CYCLE = {
  cycleType: CreativeOffer.CycleType.RECURRING,
  cycleDuration: {
    unit: CreativeOffer.DurationUnit.YEAR,
    count: 1
  }
};
export const DEFAULT_SALE_PURCHASE_CYCLE = {
  cycleType: CreativeOffer.CycleType.RECURRING,
  cycleDuration: {
    unit: CreativeOffer.DurationUnit.YEAR,
    count: 2
  }
};

// Studio color palette — references CSS custom properties defined in
// styles/colors.scss (single source of truth across TS and SCSS).
export const STUDIO_SALE_BG_COLOR = 'var(--studio-sale-bg-color)';
export const STUDIO_SALE_TEXT_COLOR = 'var(--studio-sale-text-color)';
export const STUDIO_CURRENT_PLAN_BG_COLOR = 'var(--studio-current-plan-bg-color)';
export const STUDIO_RECOMMENDED_BG_COLOR = 'var(--studio-recommended-bg-color)';
//# sourceMappingURL=consts.js.map